var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Online_Shopping-Shopping-Smartphone-Shopping_Bag-Commerce",
    "data-name": "Online Shopping-Shopping-Smartphone-Shopping Bag-Commerce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42 9v36a6 6 0 0 1 -6 6h-20a6.013 6.013 0 0 1 -5.2-3v-.01a5.939 5.939 0 0 1 -.8-2.99v-36a6 6 0 0 1 6-6h20a6 6 0 0 1 5.98 5.55c.01.15.02.3.02.45z",
    fill: "#5aaae7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 11.25v27.49a14.919 14.919 0 0 1 -4.35-2.88l-7.03 1.31 3.64-6.16a15 15 0 0 1 7.74-19.76z",
    fill: "#3d9ae2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.77 25.6a15 15 0 0 1 -17.37 12.17 12.932 12.932 0 0 1 -1.4-.32 14.927 14.927 0 0 1 -6.35-3.59l-7.03 1.31 3.64-6.16a14.995 14.995 0 0 1 16.34-20.78 15 15 0 0 1 12.17 17.37z",
    fill: "#ffd422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 20v12a2.006 2.006 0 0 0 2 2h10a2.006 2.006 0 0 0 2-2v-12z",
    fill: "#ebbf00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 28v2a2.006 2.006 0 0 1 -2 2h-10a2.006 2.006 0 0 1 -2-2v-2z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 18h14v10h-14z",
    fill: "#3d9ae2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 43a2.006 2.006 0 0 1 2 2 2.015 2.015 0 0 1 -2 2h-4a2.006 2.006 0 0 1 -2-2 2.015 2.015 0 0 1 2-2z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.9 43.71a3.012 3.012 0 0 1 -.4 1.5l-.33.58a1.9 1.9 0 0 1 -.17-.79 1.955 1.955 0 0 1 .59-1.41 2.258 2.258 0 0 1 .29-.25c.01.12.02.25.02.37z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.83 20.17a4.008 4.008 0 1 1 -2.83-1.17 4.025 4.025 0 0 1 2.83 1.17z",
    fill: "#3d9ae2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.83 18.17a4.008 4.008 0 1 1 -2.83-1.17 4.025 4.025 0 0 1 2.83 1.17z",
    fill: "#ffd422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.9 41.71a3 3 0 0 0 -5.6-1.5l-4.5 7.78a5.939 5.939 0 0 1 -.8-2.99v-15.98a2 2 0 0 0 -1.54 1.14l-4.54 9.85a9.908 9.908 0 0 0 -.92 4.18v17.81l16-.01v-4.34a6.024 6.024 0 0 0 -.86-3.09l-2.14-3.56 4.5-7.79a3.012 3.012 0 0 0 .4-1.5z",
    fill: "#ffc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 6h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 6h8v2h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 45a5.006 5.006 0 0 1 -5 5h-18.268l3.438-5.954a2.957 2.957 0 0 0 -.17.954 3 3 0 0 0 3 3h4a3 3 0 0 0 0-6h-4a2.992 2.992 0 0 0 -2.432 1.257 3.99 3.99 0 0 0 -7.13-3.551l-3.4 5.892a4.973 4.973 0 0 1 -.038-.598v-36a5.006 5.006 0 0 1 5-5h20a5.02 5.02 0 0 1 4.33 2.5l1.731-1a7.028 7.028 0 0 0 -6.061-3.5h-20a7.008 7.008 0 0 0 -7 7v19.3a3 3 0 0 0 -1.448 1.441l-4.539 9.847a10.857 10.857 0 0 0 -1.013 4.612v17.8h2v-17.8a8.863 8.863 0 0 1 .828-3.771l4.172-9.052v13.623a6.973 6.973 0 0 0 .889 3.411 1 1 0 0 0 1.781.089l4.5-7.794a2 2 0 0 1 3.464 2l-4.5 7.794a1 1 0 0 0 .009 1.016l2.142 3.56a5.018 5.018 0 0 1 .715 2.578v4.336h2v-4.336a7.012 7.012 0 0 0 -1-3.608l-1.231-2.046h18.231a7.008 7.008 0 0 0 7-7v-5h-2zm-17-1h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.11 13.82a16 16 0 0 0 -27.97 15.11l-3.38 5.73a1 1 0 0 0 .04 1.08 1.019 1.019 0 0 0 1.01.41l6.53-1.22a15.939 15.939 0 0 0 7.88 3.83 16.6 16.6 0 0 0 2.79.24 16 16 0 0 0 13.1-25.18zm.68 11.61a14 14 0 0 1 -23.45 7.7 1.011 1.011 0 0 0 -.69-.27 1.087 1.087 0 0 0 -.18.01l-4.87.91 2.52-4.26a1.042 1.042 0 0 0 .06-.91 13.88 13.88 0 0 1 -.97-8.04 14 14 0 0 1 27.58 4.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 17h-3v-1a4 4 0 0 0 -8 0v1h-3a1 1 0 0 0 -1 1v12a3.009 3.009 0 0 0 3 3h10a3.009 3.009 0 0 0 3-3v-12a1 1 0 0 0 -1-1zm-9-1a2 2 0 0 1 4 0v1h-4zm8 14a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1-1v-1h12zm0-3h-12v-8h2v2h2v-2h4v2h2v-2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.293 15.293-1.54 1.54a5.015 5.015 0 1 0 1.414 1.414l1.54-1.54zm-1.293 5.707a3 3 0 1 1 -3-3 2.951 2.951 0 0 1 1.285.3l-2.992 2.992 1.414 1.414 2.993-2.991a2.951 2.951 0 0 1 .3 1.285z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 18h4v2h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 22h4v2h-4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.5fed4be5302e385d147ccfb30a626150.svg";
export { ForwardRef as ReactComponent };